const shared = {
  className: "h-full w-full",
  viewBox: "0 0 160 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": true,
};

/** Scaffolding care — stepped support holding a conversation */
const ScaffoldGraphic = () => (
  <svg {...shared}>
    <rect
      x="12"
      y="18"
      width="136"
      height="84"
      rx="10"
      className="fill-green/10 dark:fill-green/15"
    />
    {/* Scaffold steps */}
    <rect x="22" y="78" width="52" height="10" rx="2" className="fill-green/55" />
    <rect x="30" y="62" width="52" height="10" rx="2" className="fill-green/70" />
    <rect x="38" y="46" width="52" height="10" rx="2" className="fill-green" />
    {/* Vertical posts */}
    <rect x="28" y="46" width="3" height="42" className="fill-green/40" />
    <rect x="66" y="46" width="3" height="42" className="fill-green/40" />
    {/* Dialogue bubbles */}
    <rect
      x="96"
      y="34"
      width="38"
      height="22"
      rx="8"
      className="fill-white dark:fill-darkBg stroke-green"
      strokeWidth="1.5"
    />
    <path d="M104 56 L108 64 L114 56" className="fill-white dark:fill-darkBg stroke-green" strokeWidth="1.5" />
    <rect
      x="88"
      y="68"
      width="32"
      height="18"
      rx="7"
      className="fill-green/20 stroke-green/60"
      strokeWidth="1.25"
    />
    <circle cx="106" cy="43" r="2" className="fill-green" />
    <circle cx="114" cy="43" r="2" className="fill-green" />
    <circle cx="122" cy="43" r="2" className="fill-green" />
  </svg>
);

/** Misalignment — community norms and AI pattern pulled apart */
const MisalignmentGraphic = () => (
  <svg {...shared}>
    <rect
      x="12"
      y="18"
      width="136"
      height="84"
      rx="10"
      className="fill-green/10 dark:fill-green/15"
    />
    {/* Community circle */}
    <circle
      cx="58"
      cy="60"
      r="28"
      className="fill-green/25 stroke-green"
      strokeWidth="2"
    />
    <circle cx="50" cy="54" r="5" className="fill-green" />
    <circle cx="66" cy="54" r="5" className="fill-green" />
    <circle cx="58" cy="70" r="5" className="fill-green/80" />
    {/* AI square — offset / misaligned */}
    <rect
      x="92"
      y="38"
      width="40"
      height="40"
      rx="6"
      className="fill-white dark:fill-darkBg stroke-gray-400 dark:stroke-gray-500"
      strokeWidth="2"
      strokeDasharray="4 3"
      transform="rotate(12 112 58)"
    />
    <path
      d="M102 52h16M102 58h12M102 64h14"
      className="stroke-gray-400 dark:stroke-gray-500"
      strokeWidth="1.5"
      strokeLinecap="round"
      transform="rotate(12 112 58)"
    />
    {/* Gap marker */}
    <path
      d="M78 60 H90"
      className="stroke-green"
      strokeWidth="1.5"
      strokeDasharray="2 2"
      strokeLinecap="round"
    />
  </svg>
);

/** Collaboration — human and AI side by side, human in lead */
const CollaborationGraphic = () => (
  <svg {...shared}>
    <rect
      x="12"
      y="18"
      width="136"
      height="84"
      rx="10"
      className="fill-green/10 dark:fill-green/15"
    />
    {/* Shared table / decision surface */}
    <ellipse
      cx="80"
      cy="86"
      rx="48"
      ry="10"
      className="fill-green/20"
    />
    {/* Human */}
    <circle cx="54" cy="48" r="10" className="fill-green" />
    <path
      d="M36 82c2-16 10-24 18-24s16 8 18 24"
      className="fill-green/70"
    />
    {/* AI node */}
    <rect
      x="98"
      y="38"
      width="22"
      height="22"
      rx="5"
      className="fill-white dark:fill-darkBg stroke-green"
      strokeWidth="2"
    />
    <circle cx="109" cy="49" r="3.5" className="fill-green" />
    <path
      d="M95 82c3-14 10-20 14-20s11 6 14 20"
      className="fill-green/35"
    />
    {/* Shared link / agency arrow toward human lead */}
    <path
      d="M74 58 C82 52, 90 52, 98 56"
      className="stroke-green"
      strokeWidth="2"
      strokeLinecap="round"
      fill="none"
    />
    <circle cx="80" cy="72" r="4" className="fill-green stroke-white dark:stroke-darkBg" strokeWidth="1.5" />
  </svg>
);

const graphics = {
  reflection: ScaffoldGraphic,
  misalignment: MisalignmentGraphic,
  agency: CollaborationGraphic,
};

const PillarGraphic = ({ pillarId, className = "" }) => {
  const Graphic = graphics[pillarId];
  if (!Graphic) return null;
  return (
    <div
      className={`overflow-hidden rounded-md ${className}`}
      role="img"
      aria-label=""
    >
      <Graphic />
    </div>
  );
};

export default PillarGraphic;
